import React from "react";
import { FF } from "../lib/constants";

// Publicatie-indicator, nu als vaste knop in de topbalk (rechts, naast het
// accountmenu). Oranje en klikbaar zolang er niet-gepubliceerde wijzigingen zijn;
// na een geslaagde publicatie kort groen ("gepubliceerd") in exact hetzelfde formaat.
var badgeStyle = { border: "none", height: 34, padding: "0 12px", borderRadius: 17, fontSize: 12, fontWeight: 700, fontFamily: FF, whiteSpace: "nowrap", display: "inline-flex", alignItems: "center" };

export default function PublishBanner({ show, publishing, onPublish, justPublished }) {
  if (justPublished) {
    return (
      <div role="status" style={Object.assign({}, badgeStyle, { background: "#2F7D47", color: "#fff" })}>Gepubliceerd ✓</div>
    );
  }
  if (!show) return null;
  return (
    <button onClick={onPublish} disabled={publishing} style={Object.assign({}, badgeStyle, { background: "#B85A12", color: "#fff", cursor: publishing ? "default" : "pointer", opacity: publishing ? .7 : 1 })}>{publishing ? "Bezig..." : "Publiceren"}</button>
  );
}
